// extracted by mini-css-extract-plugin
export default {"container":"eo-z","heading":"fo-z","text":"go-z","info":"ho-z","link":"io-z","fullMaxWidth":"jo-z"};